export default __webpack_public_path__ + "static/media/4.7e4545a5.jpg";